import Vue from "vue";
let fleet = require("./fleet.js");

const store = Vue.observable({
    contacts: {
        loaded: false,
        data: {
            contacts: []
        },
        contactsFull: []
    }
});

const actions = {
    async getContacts() {
        let result;
        store.contacts.loaded = false;

        try {
          result = await Vue.axios.get(`contacts`);
        }
        catch(err) {
          result = err;
        }
        if (!result || result.error) return;

        store.contacts.data.contacts = result || [];
        store.contacts.loaded = true;
    },

    async modifyContact(data) {
        let result;

        try {
          result = await Vue.axios.put(`contacts`, data);
        }
        catch(err) {
          return err;
        }
        console.log('api resp', result);
    },
    async insertContact(data) {
        let result;

        try {
          result = await Vue.axios.post(`contacts`, data);
        }
        catch(err) {
          return err;
        }
        console.log('api resp', result);
    }

}
const mutations = {
    getContactsFull() {
        let contactExtended = JSON.parse(JSON.stringify(store.contacts.data.contacts));

        fleet.default.store.fleetData.data.contracts.forEach(({auto}) => {
            let contact = contactExtended.find( ({ _id }) => _id === auto.korisnik );
            if (contact) {
                contact.vehicleId = auto._id;
                contact.vehicleName = `${auto.autoManufacturer} ${auto.modelAndManufacturer} ${auto.registracijskeTablice}`;
            }
        })
        return contactExtended;
    },
    getDashNumbers() {
        
        let numbers = {
            vehiclesWithDrivers: {
                vehicles: 0,
                withDriver: 0,
                withoutDriver: 0
            },
            drivers: {

            },
            tickets: {
                total: 0,
                solved: 0,
                unsolved: 0
            }
        };

        fleet.default.store.fleetData.data.contracts.forEach(({auto, tickets}) => {
            numbers.vehiclesWithDrivers.vehicles++;
            if (auto.korisnik) numbers.vehiclesWithDrivers.withDriver++;
            else numbers.vehiclesWithDrivers.withoutDriver++

            tickets.forEach( ticket => {
                numbers.tickets.total++;
                if (ticket && ticket.metadata && ticket.metadata.status && ticket.metadata.status === 'resolved') numbers.tickets.solved++;
                else numbers.tickets.unsolved++;
            });

            let contact = store.contacts.data.contacts.find( ({ _id }) => _id === auto.korisnik );
            if (contact) {
                numbers.drivers[contact._id] = numbers.drivers[contact._id] + 1 || 1
            }
        });
        
        numbers.vehiclesWithDrivers.percentage = numbers.vehiclesWithDrivers.withDriver / numbers.vehiclesWithDrivers.vehicles * 100;
        numbers.tickets.percentage = numbers.tickets.solved / numbers.tickets.total * 100;

        return numbers;
    }
}


export default {
    store,
    actions,
    mutations
}